import { render, staticRenderFns } from "./HomePanelButton.vue?vue&type=template&id=7b1a161d&"
import script from "./HomePanelButton.vue?vue&type=script&lang=js&"
export * from "./HomePanelButton.vue?vue&type=script&lang=js&"
import style0 from "./HomePanelButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports